// extracted by mini-css-extract-plugin
module.exports = {"root":"root-1cRNY","container":"container-3rY5V","header":"header-keipR","intro":"intro-2XhJT","error404":"error404-1zOlE","error401":"error401-1zowc"};